// Country specific JS
// All your code here should be wrapped inside functions, i.e. no code a the root of the module (beside empty variable declarations)

// here you can import other things
// import { myfunction } from './lib/mylib'
import { listenForAjax } from '../common/utils';
import { activateFuncionalities } from '../api/api';
import { addAdditionalInfo } from './create-account/addAdditionalInfo';
import { redirectCountryLinks, unslickFooter } from './footer/footer';
import { changeLibelle } from './libelle/libelle';
import { customHeader, customFooter } from './app-webview/webview-functions';
import { linksSeo } from './menu-cross/hideLinksMainMenu';
import { menuCross } from './menu-cross/menu-cross';
import { cookieSelectSize, checkIconProduct, customProduct, evaluateSimulator, initCheckSticker, printButtonAddToCart, sizeGuide ,initListeners} from './pdp/es-pdp-functions';
import { initSearchEngineTestABfuntions } from './pdp/search-testAB/search.testAB';
import {openOpinionsAccordion} from './pdp/open-opinions/open-opinions';
import { templateSuggestion } from './suggestion-template/suggestion-template';
import { refactorTextPrivacyAccepted } from './complete-account/refactorPrivacyText';

export function init() {
  // type your code here
  // it will be executed on the DOMContentLoaded event
  const removeGoProductsStorage = () => sessionStorage.removeItem('_products_go_');
  listenForAjax('/es/ajax/rest/model/atg/commerce/order/purchase/CartModifierActor/', removeGoProductsStorage);

  // Check if fragment mode is activated on legacy pages and put a nfs-framgent-active class on body to control css rules
  if (document.querySelector('div[id^="app_"].nfs')){
    document.querySelector('body').classList.add('nfs-fragment-active');
  }

  const activates = activateFuncionalities('shared');
  const activatesLogin = activateFuncionalities('login');
  const webviewConfiguration =  activateFuncionalities('webviewConfiguration');
  /**
   * Execute cross menu only for /es language, not for /ca
   */
  if (window.tc_vars.env_language === 'es' && navigator.userAgent.indexOf('variableKiosk') < 0 && activates.menuCross) {
    /* eslint-disable global-require */

    /**
     * Way to get json data information. Three different ways:
     *    * Use json data in localhost environment (first if)
     *    * Use json data in ephemeral environment for testing (second if)
     *    * Use json data in deployed environment (preprod & prod) (third if)
     */
    let menuData;

    if (window.location.origin.indexOf('localhost') >= 0 || window.location.origin.indexOf('slots-ux') >= 0) {

      menuData = require('./menu-cross/menu-information.json');
      menuCross(menuData);

    } else {
      fetch('/static/json/menu-information.json')
        .then(response => response.json())
        .then(json => {
          menuData = json;
          menuCross(menuData);
        }).catch(() => {
        // Error :(
        });

    }

    /* eslint-enable global-require */

    if(activates.linksSeo){
      linksSeo();
    }

  }

  /**
   * Script only for footer perimeter
   */
  if (jQuery('.slick-footer-links').length > 0) {
    /**
     * Fix footer links columns, unslick core footer slider and slick it again with correct properties
     */
    if(activates.unslickFooter){
      unslickFooter();
    }

    /**
    * Set redirections to country selection
    */
    if(activates.redirectCountryLinks){
      redirectCountryLinks();
    }

  }

  /**
   * On create account page add help information:
   *    * Which fields are obligatory.
   *    * What information is needed to reset their password.
   */
  if (window.tc_vars.page_name === '/create' && activates.addAdditionalInfo) {
    addAdditionalInfo();
  }

  /**
   * Call to scripts that affects on PDP
   */

  if (window.tc_vars.env_template === 'product') {

    if(activates.cookieSelectSize){
      cookieSelectSize();
    }

    if(activates.customProductPDP){
      customProduct(activates.addStockStoreButton);
    }

    if(activates.financiacion){
      /* eslint-disable global-require */
      if (window.tc_vars.product_currentprice_ati > 90) {
        evaluateSimulator();
      }
    }

    if(activates.sizeGuide){
      sizeGuide();
    }

    //Check if product is icon
    if(activates.checkIconProductPDP){
      checkIconProduct();
    }

    //Check if product has pvpr sticker
    if(activates.initCheckSticker){
      initCheckSticker();
      jQuery('.sizes__list .sizes__size').on('click', () => {
        setTimeout(
          () => { initCheckSticker(); }
          , 1);
      });
    }


    if (jQuery(window).width() <= 800 && activates.printButtonAddToCart) {
      printButtonAddToCart(activates);
    }
    if (jQuery(window).width() > 800 && activates.addStockStoreButton){
      initListeners(activates.addStockStoreButton);
    }
    if(activates.openUsersOpinions){
      openOpinionsAccordion();
    }
  }

  if(activates.changeLibelle){
    changeLibelle();
  }

  // Check if the user came to the current page using a redirection
  // the search box with the searched query using a sessionStorage
  // variable set by the search engine (repo: cube-front-core, file: sa-search-es.js).
  if (sessionStorage.searchedQuery) {
    jQuery('#search-autocomplete')[0].value = sessionStorage.searchedQuery;
    delete sessionStorage.searchedQuery;
  }

  if (webviewConfiguration.hideHeader && jQuery('body').find('#container-header').length>0 && navigator.userAgent.indexOf('dktes_app') !== -1){
    customHeader();
  }

  if (webviewConfiguration.hideFooter && jQuery('body').find('.block-footer').length>0 && navigator.userAgent.indexOf('dktes_app') !== -1){
    customFooter();
  }

  if (activates.searchTestAB && window.tc_vars.env_template === 'product') {
    initSearchEngineTestABfuntions();
  }

  if (activates.templateSuggestion && window.tc_vars.env_template === 'suggestions') {
    templateSuggestion();
  }
  if (activates.refactorTextPrivacy) {
    refactorTextPrivacyAccepted();
  }

  if (window.tc_vars.page_name === '/account/myMeansOfPayment') {
    document.querySelector('[data-payment="INGENICO_-_CREDITCARD"]').parentElement.parentElement.remove();
  }

}




// WEBPACK FOOTER //
// ./src/_override/shared/shared-country.entry.js